module.exports = __webpack_public_path__ + "img/5ad0c2b.png";